import { Component } from "react";
import { connect } from "react-redux";
import Button from "@mui/material/Button/Button";
import "./BackToTop.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowCircleUp } from "@fortawesome/free-solid-svg-icons";

class BackToTop extends Component {
    shouldComponentUpdate(nextProps) {
        let currentVisibility = this.props.context.scrollY < 500;
        let nextVisibility = nextProps.context.scrollY < 500;

        return currentVisibility !== nextVisibility;
    }

    render() {
        if (this.props.context.scrollY < 500) return null;

        return (
            <Button className="back-to-top-btn" onClick={this.props.backToTop} id="myBtn" title="On décolle">
                <FontAwesomeIcon className="fa-3x" icon={faArrowCircleUp} />
            </Button>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        context: state.context,
    };
};

const mapDispatchToProps = () => {
    return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(BackToTop);
